import React from 'react';
import { getBedarf } from '../util/functions';
import { formatFloatingNumber } from '../../shared/util/functions';
import { TextTestLogic } from '../../eye-test/logic/text-test-logic';
import '../styles/result.scss';

export const ResultSchrift: React.FunctionComponent = () => {
	const testLogic = TextTestLogic.getInstance();
	const bedarf = getBedarf();
	const testSize: number = bedarf[testLogic.currentFontSizeIndex];

	const text = ((): JSX.Element => {
		if (testSize <= 1) {
			return <>Das ist eine <strong>sehr gute</strong> Sehleistung!</>;
		}
		return (
			<>
				Ihre Sehleistung ist möglicherweise nicht optimal. Bitte vereinbaren Sie einen <strong> kostenlosen
				Termin</strong> mit unserem Team.
			</>
		);
	})();

	return (
		<p className={'standard-text'}>
			Sie haben ungefähr einen <strong>{formatFloatingNumber(testSize)}x</strong> Vergrößerungsbedarf.<br/>
			{text}
		</p>
	);
};
